import { render, staticRenderFns } from "./WaybillManagement.vue?vue&type=template&id=60be7a54&"
import script from "./WaybillManagement.vue?vue&type=script&lang=js&"
export * from "./WaybillManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports